import styles from "./index.module.scss";

export default function NoteTitle({ title }: { title: string }): JSX.Element {
  return (
    <h2 className={styles.title} data-e="note-title">
      {title}
    </h2>
  );
}
